const Environment = {

    env: process.env.NODE_ENV,

    isProduction() {
        return this.env === 'production';
    },

    isTest() {
        return this.env === 'test';
    },

    isDevelopment() {
        return this.env === 'development';
    }
};

export {Environment};
